import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_bootstrapvue_2905b2cf from 'nuxt_plugin_bootstrapvue_2905b2cf' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_plugin_2251d4b8 from 'nuxt_plugin_plugin_2251d4b8' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_pluginseo_f3a928a2 from 'nuxt_plugin_pluginseo_f3a928a2' // Source: ./nuxt-i18n/plugin.seo.js (mode: 'all')
import nuxt_plugin_pluginrouting_20f26026 from 'nuxt_plugin_pluginrouting_20f26026' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_0a5e25ee from 'nuxt_plugin_pluginmain_0a5e25ee' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_modernizrclient_14a54a0a from 'nuxt_plugin_modernizrclient_14a54a0a' // Source: ../../../plugins/modernizr.client.js (mode: 'client')
import nuxt_plugin_lazysizesclient_60ea0274 from 'nuxt_plugin_lazysizesclient_60ea0274' // Source: ../../../plugins/lazysizes.client.js (mode: 'client')
import nuxt_plugin_countupclient_49f5fc92 from 'nuxt_plugin_countupclient_49f5fc92' // Source: ../../../plugins/countup.client.js (mode: 'client')
import nuxt_plugin_vuescrolltoclient_6b7b8883 from 'nuxt_plugin_vuescrolltoclient_6b7b8883' // Source: ../../../plugins/vue-scrollto.client.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    return this.$root.$options.$nuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":"%s","title":"ONDIGO","meta":[{"http-equiv":"Content-Type","content":"text\u002Fhtml; charset=utf-8"},{"http-equiv":"X-UA-Compatible","content":"IE=edge"},{"name":"viewport","content":"width=device-width, initial-scale=1.0, maximum-scale=5.0"},{"name":"robots","content":"index, follow"},{"name":"msapplication-TileColor","content":"#da532c"},{"name":"msapplication-TileImage","content":"\u002Fmstile-144x144.png"},{"name":"theme-color","content":"#00214B"},{"name":"twitter:card","content":"summary_large_image"},{"name":"twitter:image","content":"https:\u002F\u002Fwww.ondigo.de\u002F2020-02-03_ON_og-image.jpg"},{"name":"og:image","content":"https:\u002F\u002Fwww.ondigo.de\u002F2020-02-03_ON_og-image.jpg"},{"property":"og:image:width","content":"1200"},{"property":"og:image:height","content":"1200"},{"property":"og:type","content":"website"},{"name":"google-site-verification","content":"SKkhzmyhML_aE-DydlAGoQqTrcJfXoLoFqys5MSMpWM"},{"name":"geo.placename","content":"Pfuelstr. 5, 10997 Berlin, Deutschland"},{"name":"geo.position","content":"52.5073470;13.3215620"},{"name":"geo.region","content":"DE-Berlin"},{"name":"ICBM","content":"52.5073470, 13.3215620"}],"link":[{"rel":"apple-touch-icon","sizes":"57x57","href":"\u002F2017-apple-touch-icon-57x57.png"},{"rel":"apple-touch-icon","sizes":"60x60","href":"\u002F2017-apple-touch-icon-60x60.png"},{"rel":"apple-touch-icon","sizes":"72x72","href":"\u002F2017-apple-touch-icon-72x72.png"},{"rel":"apple-touch-icon","sizes":"76x76","href":"\u002F2017-apple-touch-icon-76x76.png"},{"rel":"apple-touch-icon","sizes":"114x114","href":"\u002F2017-apple-touch-icon-114x114.png"},{"rel":"apple-touch-icon","sizes":"120x120","href":"\u002F2017-apple-touch-icon-120x120.png"},{"rel":"apple-touch-icon","sizes":"144x144","href":"\u002F2017-apple-touch-icon-144x144.png"},{"rel":"apple-touch-icon","sizes":"152x152","href":"\u002F2017-apple-touch-icon-152x152.png"},{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002F2017-apple-touch-icon-180x180.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002F2017-favicon-32x32.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"194x194","href":"\u002F2017-favicon-194x194.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"192x192","href":"\u002F2017-favicon-192x192.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002F2017-favicon-16x16.png"},{"rel":"manifest","crossorigin":"use-credentials","href":"\u002Fmanifest.json"},{"rel":"mask-icon","href":"\u002F2017-safari-pinned-tab.svg","color":"#00214B"},{"rel":"preload","as":"font","crossorigin":"anonymous","type":"font\u002Fwoff","href":"\u002Ffont\u002FZwoWebPro.woff"},{"rel":"preload","as":"font","crossorigin":"anonymous","type":"font\u002Fwoff","href":"\u002Ffont\u002FZwoWebPro-Bold.woff"},{"rel":"preload","as":"font","crossorigin":"anonymous","type":"font\u002Fwoff","href":"\u002Ffont\u002FZwoWebPro-Semibold.woff"}],"script":[{"innerHTML":"document.addEventListener(\"touchstart\", function(){}, {passive: true});"},{"type":"application\u002Fld+json","json":{"@context":"https:\u002F\u002Fschema.org","@type":"LocalBusiness","image":"https:\u002F\u002Fwww.ondigo.de\u002F2020-03-03_ON-rs.jpg","logo":"https:\u002F\u002Fwww.ondigo.de\u002F2020-03-03_ON-rs.jpg","email":"skygate@skygate.de","name":"SkyGate","legalName":"SkyGate internetworking GmbH","priceRange":"EUR","telephone":"030 611 03 8 0","faxNumber":"030 612 80 465","url":"https:\u002F\u002Fwww.ondigo.de","numberOfEmployees":"60","aggregateRating":{"@type":"AggregateRating","ratingValue":"5.0","reviewCount":"4"},"address":{"@type":"PostalAddress","addressCountry":"Deutschland","addressLocality":"Berlin","postalCode":"10997","streetAddress":"Pfuelstraße 5"},"geo":{"@type":"GeoCoordinates","latitude":52.50268,"longitude":13.44087},"openingHoursSpecification":[{"@type":"OpeningHoursSpecification","dayOfWeek":"Monday","opens":"08:30","closes":"18:00"},{"@type":"OpeningHoursSpecification","dayOfWeek":"Tuesday","opens":"08:30","closes":"18:00"},{"@type":"OpeningHoursSpecification","dayOfWeek":"Wednesday","opens":"08:30","closes":"18:00"},{"@type":"OpeningHoursSpecification","dayOfWeek":"Thursday","opens":"08:30","closes":"18:00"},{"@type":"OpeningHoursSpecification","dayOfWeek":"Friday","opens":"08:30","closes":"18:00"}],"founders":[{"@type":"Person","givenName":"Sven","familyName":"Liebchen","email":"liebchen@skygate.de","telephone":"030 611 03 8 0","image":"https:\u002F\u002Fwww.ondigo.de\u002F2018-05-02-ON_team-sven_liebchen500x500.jpg"},{"@type":"Person","givenName":"Philipp","familyName":"Heine","email":"heine@skygate.de","telephone":"030 611 03 8 0","image":"https:\u002F\u002Fwww.ondigo.de\u002F2018-05-02-ON_team-philipp_heine500x500.jpg"}]}}],"__dangerouslyDisableSanitizers":["script"],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_bootstrapvue_2905b2cf === 'function') {
    await nuxt_plugin_bootstrapvue_2905b2cf(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_2251d4b8 === 'function') {
    await nuxt_plugin_plugin_2251d4b8(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginseo_f3a928a2 === 'function') {
    await nuxt_plugin_pluginseo_f3a928a2(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_20f26026 === 'function') {
    await nuxt_plugin_pluginrouting_20f26026(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_0a5e25ee === 'function') {
    await nuxt_plugin_pluginmain_0a5e25ee(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_modernizrclient_14a54a0a === 'function') {
    await nuxt_plugin_modernizrclient_14a54a0a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_lazysizesclient_60ea0274 === 'function') {
    await nuxt_plugin_lazysizesclient_60ea0274(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_countupclient_49f5fc92 === 'function') {
    await nuxt_plugin_countupclient_49f5fc92(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrolltoclient_6b7b8883 === 'function') {
    await nuxt_plugin_vuescrolltoclient_6b7b8883(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, (err) => {
        // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
        if (!err._isRouter) return reject(err)
        if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
